// Quick-buy: opens product in a centered modal (popup), not a side drawer.
// Fetches product.ajax-modal view and shows image left, content right.
if (customElements.get('quick-buy') === undefined) {

  customElements.define('quick-buy', class QuickBuy extends HTMLElement {
    constructor() {
      'use strict';
      super();

      this.processingModal = false;
      this.button = this.querySelector('a[href*="modal"]');

      if (!this.button) {
        console.error('Quick buy button not found');
        return;
      }

      this.targetModalId = this.button.getAttribute('href').substring(1);
      this.quickBuyProductHandle = this.button.dataset.productHandle || this.dataset.productHandle;
      this.rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/';

      // Extract product ID from modal ID (format: modal-{productId}-product)
      const modalIdMatch = this.targetModalId.match(/modal-(\d+)-product/);
      const productId = modalIdMatch ? modalIdMatch[1] : this.quickBuyProductHandle;

      this.dataset.product = productId;
      this.dataset.url = this.button.dataset.url || this.dataset.url || `${this.rootUrl}products/${this.quickBuyProductHandle}`;

      this.button.addEventListener('click', this.onModalRequestOpen.bind(this));
    }

    async onModalRequestOpen(event) {
      event.preventDefault();
      if (this.processingModal === true) {
        return;
      }

      this.button.classList.add('loading');
      this.button.querySelector('.loading-overlay')?.classList.remove('hidden');

      const modal = document.getElementById(this.targetModalId);

      if (modal) {
        modal.querySelectorAll('.model-info-input').forEach((input) => {
          input.checked = false;
        });
        Woolman.ModalsAndDrawers.showModalOrDrawer(this.targetModalId);
        this.button.classList.remove('loading');
        this.button.querySelector('.loading-overlay')?.classList.add('hidden');
        return;
      }

      this.processingModal = true;

      document.querySelectorAll('[data-quick-buy-modal]').forEach((el) => {
        el.remove();
      });

      try {
        if (!this.quickBuyProductHandle) {
          throw new Error('Quick buy product handle is missing');
        }

        const res = await fetch(`${this.rootUrl}products/${this.quickBuyProductHandle}?view=ajax-modal`);

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const modalElement =
          doc.getElementById(this.targetModalId) ||
          doc.body.firstElementChild;

        if (!modalElement) {
          throw new Error('Quick buy modal HTML did not contain a modal element');
        }
        document.body.appendChild(modalElement);
        modalElement.querySelectorAll('.model-info-input').forEach((input) => {
          input.checked = false;
        });
        setTimeout(() => {
          this.button.classList.remove('loading');
          this.button.querySelector('.loading-overlay')?.classList.add('hidden');
          Woolman.ModalsAndDrawers.showModalOrDrawer(this.targetModalId);
        }, 100);

        this.modal = modalElement;
        this.hookEvents();
      } catch (error) {
        console.error('Error loading quick buy modal:', error);
        this.button.classList.remove('loading');
        this.button.querySelector('.loading-overlay')?.classList.add('hidden');
        this.processingModal = false;

        // Fallback: keep the purchase journey moving even if modal fetch fails.
        if (this.dataset.url) {
          window.location.href = this.dataset.url;
        }
      }
    }

    hookEvents() {
      const closeButton = this.modal.querySelector('[data-close]');
      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          this.classList.add('is-closing');
          if (this.button) this.button.blur();
          Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent(e);
          setTimeout(() => this.cleanupModal(), 300);
        });
      }

      const overlay = this.modal.querySelector('[data-overlay]');
      if (overlay) {
        overlay.addEventListener('click', (e) => {
          this.classList.add('is-closing');
          if (this.button) this.button.blur();
          Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent(e);
          setTimeout(() => this.cleanupModal(), 300);
        });
      }

      const productForm = document.getElementById(`product-form-${this.dataset.product}`);
      if (productForm) {
        productForm.addEventListener('submit', this.handleSubmit.bind(this));
      }

      this.processingModal = false;
    }

    async handleSubmit() {
      this.classList.add('is-closing');
      if (this.button) this.button.blur();
      const overlay = this.modal.querySelector('[data-overlay]');
      if (overlay) overlay.click();
      Woolman.ModalsAndDrawers.closeModalOrDrawer(this.targetModalId);

      setTimeout(() => {
        this.cleanupModal();
      }, 300);
    }

    cleanupModal() {
      if (this.modal && this.modal.parentNode) {
        this.classList.remove('is-closing');
        if (this.button) this.button.blur();
        const closeButton = this.modal.querySelector('[data-close]');
        if (closeButton) {
          closeButton.removeEventListener('click', Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent);
        }

        const overlay = this.modal.querySelector('[data-overlay]');
        if (overlay) {
          overlay.removeEventListener('click', Woolman.ModalsAndDrawers.closeModalOrDrawerOrDrawerFromEvent);
        }

        const productForm = document.getElementById(`product-form-${this.dataset.product}`);
        if (productForm) {
          productForm.removeEventListener('submit', this.handleSubmit.bind(this));
        }

        this.modal.remove();
        this.modal = null;
      }
    }
  });
}
